<template>
	<div class="greatest-common-factor">
		<div>Factors of {{ terms.slice(0,-1).join(', ') }} and {{ terms[terms.length-1] }}</div>
		<ol>
			<li v-for="(item, i) in terms" :key="`term-${i}`">Factors of {{ item }}: 
				<span v-for="(multi, j) in factors(item)" :class="[{'result':multi==result}]" :key="`fact-${i}-${j}`"> {{ multi }},</span> 
			</li>
		</ol>
		<div>The highest common factor of {{ terms.slice(0,-1).join(', ') }} and {{ terms[terms.length-1] }} is <span class="result">{{ result }}</span></div>
	</div>
</template>
<script type="text/javascript">
	const $operations = require("../scripts/variables").operations;
	export default{
		name:'greatest-common-factor',
		props:{
			terms:{
				required: true,
				type: Array
			}
		},
		data(){
			return {
				result: $operations.gcf(this.terms),
			}
		},
		methods:{
			factors(nbre){
				let res = [];
				for(let i = 2; i <= nbre / 2; i++){
					if(nbre % i == 0 ){
						res.push(i);
					}
				}
				res.push(nbre);
				return res;
			}
		}
	};
</script>